import { useWizard } from 'react-use-wizard';

import styles from './ProgressBar.module.less';

/**
 * Wizard progress indicator. Reads `activeStep` and `stepCount` from
 * `react-use-wizard`'s context, so it must be rendered inside a `<Wizard>`
 * (typically as the `header` slot).
 */
export const ProgressBar = () => {
  const { activeStep, stepCount } = useWizard();
  const fill = stepCount === 0 ? 0 : ((activeStep + 1) / stepCount) * 100;
  const fillRounded = Math.round(fill);
  return (
    <div
      className={styles.track}
      role="progressbar"
      aria-valuemin={0}
      aria-valuemax={100}
      aria-valuenow={fillRounded}
      aria-valuetext={`Step ${activeStep + 1} of ${stepCount}`}
    >
      <div className={styles.fill} style={{ width: `${fill}%` }} />
    </div>
  );
};
